import ManagedGridView from "../controls/ManagedGridView";
import { SearchQuery } from "../code/search-query/search-query";
import {
  platformPermissionsViewColumns,
  platformPermissionsSearchSchema,
  mapPlatformPermissionsViewQuery,
} from "./PlatformPermissionsView.default";
import { getPlatformRolesPermissions } from "../repository/data.repository";
import { createGridRequest } from "../hooks/useGridRequest";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";

export interface PlatformPermissionsViewProps {
  readonly trigger?: string;
  readonly onAction?: (key: string, record: any) => void;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
}

function PlatformPermissionsView(props: PlatformPermissionsViewProps) {
  const permissions = useSelector(authorizeSelectors.permissions);
  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={platformPermissionsViewColumns}
      schema={platformPermissionsSearchSchema}
      mapQuery={mapPlatformPermissionsViewQuery}
      onSearch={props.onSearch}
      request={createGridRequest(getPlatformRolesPermissions, { retry: true })}
      pageSize={100}
      actions={[
        {
          key: "update",
          label: "Edit",
          disabled: !permissions.can("PlatformRolesPermissions", "edit"),
          handler: (key, record) => props.onAction?.(key, record),
        },
        {
          key: "delete",
          label: "Delete",
          danger: true,
          disabled: !permissions.can("PlatformRolesPermissions", "delete"),
          handler: (key, record) => props.onAction?.(key, record),
        },
      ]}
    />
  );
}

export default PlatformPermissionsView;
